let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jPaud")).then(() => parcelRequire('jBLt3'));